import { jsx as _jsx } from "react/jsx-runtime";
import { Children, createContext, isValidElement, useContext, useEffect, useMemo, useState } from 'react';
import { ERROR, HINT, INPUT, TEXTAREA } from '../../constants';
import { useId } from '../../hooks';
function findChildRecursively(children, callback) {
    return Children.toArray(children).some(child => {
        if (isValidElement(child)) {
            if (callback(child)) {
                return true;
            }
            if (child.props.children) {
                return findChildRecursively(child.props.children, callback);
            }
        }
        return false;
    });
}
const Context = createContext({
    hasHint: false,
    id: '',
    isInvalid: false,
    isLoading: false,
    isRequired: false,
    setIsLoading: () => { }
});
function Provider({ id: customId, children, ...rest }) {
    const [isLoading, setIsLoading] = useState(false);
    const id = useId(customId);
    const [hasHint, setHasHint] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);
    const [isRequired, setIsRequired] = useState(false);
    useEffect(() => {
        const checkChild = (child) => {
            setIsInvalid(false);
            if (isValidElement(child)) {
                const { displayName } = child.type;
                if (displayName === ERROR) {
                    setIsInvalid(true);
                    return true;
                }
                else if (displayName === HINT) {
                    setHasHint(true);
                }
                else if (displayName === INPUT || displayName === TEXTAREA) {
                    setIsRequired(!!child.props.required);
                }
                if (child.props.children) {
                    return findChildRecursively(child.props.children, checkChild);
                }
            }
            return false;
        };
        findChildRecursively(children, checkChild);
    }, [children]);
    const value = useMemo(() => ({
        hasHint,
        id,
        isInvalid,
        isLoading,
        isRequired,
        setIsLoading
    }), [id, isLoading, hasHint, isInvalid, isRequired]);
    return (_jsx(Context.Provider, { value: value, ...rest, children: children }));
}
const useFieldContext = () => useContext(Context);
export { Context, Provider, useFieldContext };
//# sourceMappingURL=Context.js.map